import MedidorAnormalidadDAL from '../DAL/MedidorAnormalidadDAL';
import ParametrosGeneralesDAL from '../DAL/ParametrosGaneralesDAL';
import FacturaDetalleDAL from '../DAL/FacturaDetalleDAL';
import GeneracionLecturaDAL from '../DAL/GeneracionLecturaDAL';
import FacturaDAL from '../DAL/FacturaDAL';
import FechaHora from '@/utils/FechaHora';

import { getDataBase } from '../db';
import PaqueteTodoFacilController from '../controllers/PaqueteTodoFacilController';

export default class FacturaBLL {
    // Variables n (numericos)
    gnGeneracionFactura;
    gnServicio;
    gnPlomero;
    gnFactura;
    gnCategoria;
    gnMedidorAnormalidad;
    gnError;
    gnLecturado;
    gnMoneda = 2;  // Valor por defecto
    gnMto_Pago;
    
    gnId_Tipo;
    gnTipo;
    gnTipoCambio;
    gnCobro;

    // Variables o (objetos)
    goParametrosGenerales;
    goCategoria;
    goFecha;
    goCategoriaDetalle;
    goIndicePrecioConsumidor;
    
    goGeneracionLectura;
    goFacturaDetalle;
    goCliente;
    goGeneracionFactura;
    goCredito;

    // Variables DAL (Data Access Layers)
    ParametrosGeneralesDALxd;
    CategoriaDetalleDAL;
    CategoriaDAL;
    FacturaDAL;
    ClienteDAL;
    MedidorAnormalidadDAL;
    CreditoDAL;

    // FechaDAL;
    FacturaDetalleDAL;
    GeneracionLecturaDAL;
    GeneracionFacturaDAL;
    IndicePrecioConsumidorDAL;
    ReglaLecturacion;

    constructor() {
        // El constructor puede inicializar algunas de las variables si es necesario
        // $this->IndicePrecioConsumidorDAL = new IndicePrecioConsumidorDAL; //SOLO OCUPA EL METODO SEEK
        this.MedidorAnormalidadDAL = new MedidorAnormalidadDAL; 
        this.ParametrosGeneralesDALxd = new ParametrosGeneralesDAL();
        // $this->GeneracionFacturaDAL      = new GeneracionFacturaDAL;//SOLO TRAER EL FIRST DE DICAH GENERACION FACTURA
        this.GeneracionLecturaDALXD     = new GeneracionLecturaDAL; //GETBY Y UPDATE
        // $this->CategoriaDetalleDAL       = new CategoriaDetalleDAL; //
        this.FacturaDetalleDAL = new FacturaDetalleDAL(); //es solo un metodo
        // $this->CategoriaDAL              = new CategoriaDAL;
        this.FacturaDAL    = new FacturaDAL;
        // $this->ClienteDAL                = new ClienteDAL; //TRAER INFO 
        // $this->CreditoDAL                = new CreditoDAL;
        //// $this->FechaDAL                  = new FechaDAL;

        this.ReglaLecturacion = {
             LECTURA_PENDIENTE : 1,
             LECTURA_ACTUAL   : 2,
             FIN_DE_CICLO     : 3,
             CONSUMO_PROMEDIO : 4,
             MEDIDOR_VOLCADO  : 5,
             CONSUMO_ASIGNADO : 6,    
        }
    }

    // async TieneFacturaGeneradoDeSyscoop





    async RecalcularFacturaFull(GeneracionFactura, Cliente, Plomero, DataBaseAlias,toClienteGeneracinLectura, toZonaGeneracionFactura) {
        this.gnError = 0;
        const loPaquete = new PaqueteTodoFacilController();
        try {
            // Traer la fecha con el último día
            this.goFecha = await this.GetRegistroDiaActual();
            this.goParametrosGenerales = await this.ParametrosGeneralesDALxd.GetAlldt(DataBaseAlias);
            this.goGeneracionLectura = await this.GeneracionLecturaDALXD.GetIDBy(GeneracionFactura, Cliente, DataBaseAlias); // TODO : se le aumentó $GeneracionFactura
            await this.DO_RecalcularValoresLecturas(GeneracionFactura, Cliente, DataBaseAlias);
            this.goGeneracionLectura = await this.GeneracionLecturaDALXD.GetIDBy(GeneracionFactura, Cliente, DataBaseAlias); // TODO : se le aumentó $GeneracionFactura
          
            // this.goGeneracionLectura = [];
            // this.goGeneracionLectura.push(toClienteGeneracinLectura);

            
            // Actualizar la lectura después de recalcular valores
            //no hace falta de mometno por que se actualizo en la aavrible global
            // this.goGeneracionLectura = await this.GeneracionLecturaDALXD.GetIDBy(GeneracionFactura, Cliente, DataBaseAlias);
    
            let lnLecturaActual = 0;
            let lnConsumo = 0;
            let lnMedidorAnormalidad = 0;
            this.gnPlomero = Plomero;

            // this.goGeneracionFactura = await this.GeneracionFacturaDAL.GetRecDt(GeneracionFactura, DataBaseAlias);
            this.goGeneracionFactura = [];
            this.goGeneracionFactura.push(toZonaGeneracionFactura);
            this.gnCobro = this.goGeneracionFactura[0].Cobro;
       
            //numero de factura 
            const loResFactura = await this.FacturaDAL.GetIDBy(Cliente, this.gnCobro, DataBaseAlias);
            // this.gnFactura = toClienteGeneracinLectura.Factura;
            if (loResFactura.error == 1) {
                loPaquete.error = 1;
                loPaquete.status = 0;
                loPaquete.values = 'error-get-factura';
                loPaquete.message = loResFactura.message;
                return loPaquete;
            }

            this.gnFactura = loResFactura.values;
            this.gnGeneracionFactura = GeneracionFactura;
            this.goFacturaDetalle = await this.FacturaDetalleDAL.Seek(this.gnFactura, DataBaseAlias);
    
            

            //en generacion lectura esta la info de cliente 
            // this.goCliente = await this.ClienteDAL.GetIDBy(Cliente, DataBaseAlias);
            //categoria, cloaca y seguro es lo que se ocucpa de goCliente
            this.goCliente = [];
            this.goCliente.push({
                Categoria: toClienteGeneracinLectura.Categoria,
                Cloaca: toClienteGeneracinLectura.Cloaca,
                Seguro: toClienteGeneracinLectura.Seguro,
            });

          
            // this.goIndicePrecioConsumidor = await this.IndicePrecioConsumidorDAL.Seek(this.gnCobro, DataBaseAlias);
            this.goIndicePrecioConsumidor = await this.SeekIndicePrecioConsumir(this.gnCobro);
        
            if (this.goGeneracionLectura.length > 0) {
                lnLecturaActual = this.goGeneracionLectura[0].LecturaActual;
                lnConsumo = this.goGeneracionLectura[0].Consumo;
                lnMedidorAnormalidad = this.goGeneracionLectura[0].MedidorAnormalidad;
                this.gnLecturado = lnLecturaActual > 0 || lnConsumo > 0 || lnMedidorAnormalidad > 0;
            }
    
            if (this.goFecha.length > 0) {
                const dFechaActual = this.goFecha[0].Dia;
                this.gnTipoCambio = this.goFecha[0].CambioCompra;
            }
    
            this.gnCategoria = this.goCliente[0].Categoria;
    
   
            await this.verConsumo(Cliente, Plomero, DataBaseAlias);
            await this.verAlcantar(Cliente, Plomero, DataBaseAlias);
            await this.verLey1886(Cliente, DataBaseAlias);
    
            loPaquete.values = await this.DO_GrabarFactura(this.gnFactura, GeneracionFactura, Cliente, Plomero, lnLecturaActual, lnConsumo, lnMedidorAnormalidad, DataBaseAlias, toClienteGeneracinLectura);
            return loPaquete;
        } catch (error) {
            console.error('Error en RecalcularFacturaFull:', error);
            const lcMensaje = error.message ? error.message : 'Error al crear factura';
        
            loPaquete.error = 1;
            loPaquete.status = 0;
            loPaquete.message = 'Error: Ocurrió un error inesperado, contacte con soporte';
            loPaquete.messageSistema = lcMensaje;
            return loPaquete;
        }
    }


    
    async SeekIndicePrecioConsumir(tcCobro){
        //consulta a la base de datos locla indexDnb
      
        try {
                const db = await getDataBase();
                const tx = db.transaction('INDICEPRECIOCONSUMIDOR', 'readonly');
                const store = tx.objectStore('INDICEPRECIOCONSUMIDOR');
                //CREAR INDEX 
                const index = store.index('Cobro'); 
                //A[PLICAR GETALL()
                const loData = await index.getAll(tcCobro);
                await tx.done;
                return loData;

        } catch (error) {
            console.error('Error en GetRegistroDiaActual:', error);
            return -1;
        }
    
    }

    async GetRegistroDiaActual(){
        //consulta a la base de datos locla indexDnb
        try {
                const db = await getDataBase();
                const tx = db.transaction('FECHA', 'readonly');
                const store = tx.objectStore('FECHA');
                const loFecha = await store.getAll();
                await tx.done;
                return loFecha;
        } catch (error) {
            console.error('Error en GetRegistroDiaActual:', error);
            return -1;
        }
    }

    async GetCategoriaTable(tnCategoria){
        //consulta a la base de datos locla indexDnb
        try {
            const db = await getDataBase();
            const tx = db.transaction('CATEGORIA', 'readonly');
            const store = tx.objectStore('CATEGORIA');
            const laDato = await store.getAll(Number(tnCategoria));
            await tx.done;
            return laDato;
        } catch (error) {
            console.error('Error en GetCategoriaTable:', error);
            return [];
        }
    }

    async GetCategoriaDetalleTable(tnCategoria){
        //consulta a la base de datos locla indexDnb
        try {
           
            const db = await getDataBase();
            const tx = db.transaction('CATEGORIADETALLE', 'readonly');
            const store = tx.objectStore('CATEGORIADETALLE');
            const index = store.index('Categoria');
            const laDato = await index.getAll(Number(tnCategoria));
            await tx.done;
            return laDato;
        } catch (error) {
            console.error('Error en GetCategoriaTable:', error);
            return [];
        }
    }
   
    async GetCurCreditosCliente(tnCategoria){
        console.error('ERROR: AUN SE DEBE IMPLEMENTARSE');
        
        return [];


        // try {
        //     const db = await getDataBase();
        //     const tx = db.transaction('CREDITO', 'readonly');
        //     const store = tx.objectStore('CREDITO');
        //     const laDato = await store.getAll(Number(tnCategoria));
        //     await tx.done;
        //     return laDato;
        // } catch (error) {
        //     console.error('Error en GetCurCreditosCliente:', error);
        //     return [];
        // }
    }

    actIPC(Monto) {
        Monto = Number(Monto);
        if (this.gnMoneda == 3) {
            let lnIndice;
            if (this.goIndicePrecioConsumidor.length == 1) {
                lnIndice = Number(this.goIndicePrecioConsumidor[0].Indice);
                let lnResult = Monto * lnIndice;
                // Se redondea el resultado a 6 dígitos para mayor precisión
                lnResult = Math.round(lnResult * 1000000) / 1000000;
                return lnResult;
            }
        }
        
        return Monto;
    }


    

    //solo actualizar el campo consumo facturado
    async UpdateGeneracionLectura(toDatosActualizar){
        // public function Update($laDatosActualizar){
        //     $loGeneracionLectura = GeneracionLectura::on($laDatosActualizar['DataBaseAlias'])
        //         ->where('GeneracionFactura', '=', $laDatosActualizar['GeneracionFactura'])
        //         ->where('Cliente', '=', $laDatosActualizar['Cliente'])
        //         ->update(["ConsumoFacturado" => $laDatosActualizar['ConsumoFacturado']]);
    
        //     return $loGeneracionLectura;
        // }
    }
    
    //emtodo para actualizar el campo de ConsumoFacturado
    async DO_RecalcularValoresLecturas(GeneracionFactura, Cliente, DataBaseAlias) {
  
        let lnConsumoFacturado = this.goGeneracionLectura[0].ConsumoFacturado; // TODO: recalcula para actualizar ConsumoFacturado = Consumo
        
        // Obtener medidor anormalidad, array 
        let MedidorAnormalidad = await this.MedidorAnormalidadDAL.GetRecDt(this.goGeneracionLectura[0].MedidorAnormalidad, DataBaseAlias);
   
        // Crear objeto de datos a actualizar
        let laDatosActualizar = {
            GeneracionFactura: GeneracionFactura,
            Cliente: Cliente,
            ConsumoFacturado: lnConsumoFacturado,
            DataBaseAlias: DataBaseAlias
        };
    
        // // Actualizar la lectura
        await this.GeneracionLecturaDALXD.Update(laDatosActualizar);
        // this.goGeneracionLectura[0].ConsumoFacturado = laDatosActualizar.ConsumoFacturado;

    
        if (MedidorAnormalidad.length > 0 && MedidorAnormalidad[0].MedidorAnormalidad > 0) {
            let lnRegla = MedidorAnormalidad[0].Regla;
    
            // Verificar si la regla es CONSUMO_PROMEDIO
            if (lnRegla == this.ReglaLecturacion.CONSUMO_PROMEDIO) {
                lnConsumoFacturado = this.goGeneracionLectura[0].Media;
                
                // Actualizar de nuevo con los nuevos valores
                laDatosActualizar.ConsumoFacturado = lnConsumoFacturado;

                await this.GeneracionLecturaDALXD.Update(laDatosActualizar);

                // this.goGeneracionLectura[0].ConsumoFacturado =  laDatosActualizar.ConsumoFacturado;
            }
        }
    }
    

    async verConsumo(Cliente, Plomero, DataBaseAlias) {
        try {
       
            // Obtener los valores iniciales
            this.gnServicio = this.goParametrosGenerales[0].Consumo;
            this.gnTipo = 1;
            this.gnId_Tipo = this.gnGeneracionFactura;
            let lcFiltro = this.gnCategoria;
    
            // Aplicar filtro de categoría
            // this.goCategoria = await this.CategoriaDAL.SetFilter(lcFiltro, DataBaseAlias);
            this.goCategoria = await this.GetCategoriaTable(lcFiltro);
    
            // Si no se encuentra la categoría, se aplica una por defecto
            if (this.goCategoria.length == 0) {
                lcFiltro = 1; // Categoría por defecto para Consumo
                // this.goCategoria = await this.CategoriaDAL.SetFilter(lcFiltro, DataBaseAlias);
                this.goCategoria = await this.GetCategoriaTable(lcFiltro);
            }
    
            // Obtener el consumo facturado y la moneda
            const lnConsumoFacturado = this.goGeneracionLectura[0].Consumo;
            this.gnMoneda = this.goCategoria[0].Moneda;
    
            // Calcular el monto a pagar basado en el consumo
            this.gnMto_Pago = await this.r_consumo(lnConsumoFacturado, Cliente, DataBaseAlias);
    
          
            // Ajustar moneda si es necesaria
            if (this.gnMoneda == 3) {
                this.gnMoneda = 2;
            }
    
            let lnMontoLey1294 = this.gnMto_Pago;
    
             //TODO AQUI
            // Grabar el detalle del consumo
            await this.DO_GrabarDetalle(Cliente, 1, 0, DataBaseAlias); // 1 = Consumo
    
            // Ley 1294: Cargo Fijo y Consumo
            if (this.goCategoria[0].CargoAAPP > 0) {
                this.gnServicio = this.goCategoria[0].CargoAAPP;
                this.gnTipo = 1;
                this.gnId_Tipo = this.gnGeneracionFactura;
                this.gnMto_Pago = this.goCategoria[0].MontoCargoAAPP;
                this.gnMoneda = this.goCategoria[0].Moneda;
    
                // Grabar el detalle del cargo fijo
                await this.DO_GrabarDetalle(Cliente, this.gnTipo, this.gnServicio, DataBaseAlias);
    
                // Actualizar el monto total con el cargo adicional de la Ley 1294
                lnMontoLey1294 += this.gnMto_Pago;
            }
        } catch (ex) {
            console.error("Error en FacturaBLL.verConsumo: ", ex);
        }
    }


    async r_consumo(ConsumoFacturado, Cliente, DataBaseAlias) {
        try {
            let Categoria = 0;
            let Rango = 0;
            let lnTotal = 0;
            let ConsumoCnt = 0;
            let i = -1;
            const lnPrecioConMedidor = Number(this.goCategoria[0].PrecioConMedidor);
            const lnPrecioSinMedidor = Number(this.goCategoria[0].PrecioSinMedidor);
            const lnConsumoMinimo = Number(this.goCategoria[0].ConsumoMinimo);
    
            if (this.goCategoria[0].ComoAplicaMinimo == 1) {
                const lnMonto = this.gnLecturado ? lnPrecioConMedidor : lnPrecioSinMedidor;
                lnTotal =  Number(this.actIPC(lnMonto));
    
                if (!this.gnLecturado) {
                    return lnTotal;
                }
    
                ConsumoCnt = ConsumoFacturado;
                const lcFiltro = this.gnCategoria;
                   //TODO AQUI
                // this.goCategoriaDetalle = await this.CategoriaDetalleDAL.Seek(lcFiltro, DataBaseAlias);
                this.goCategoriaDetalle = await this.GetCategoriaDetalleTable(lcFiltro);
                let r_ini = 0;
                let r_fin = 0;
                i = 0;
                let ipcValue = 0;
                let total_acc = 0;
                let rangoDiff = 0;
                const Inicio = [];
                const Fin = [];
                const Total = [];
    
                if (ConsumoFacturado > lnConsumoMinimo) {
                    let swNoSalir = true;
                    do {
                        if (i > this.goCategoriaDetalle.length - 1) {
                            swNoSalir = false;
                        }
    
                        r_ini = this.goCategoriaDetalle[i].Inicio;
                        r_fin = this.goCategoriaDetalle[i].Fin;
                        Inicio[i] = r_ini;
                        Fin[i] = r_fin;
    
                        if (r_ini <= ConsumoFacturado && ConsumoFacturado <= r_fin) {
                            ipcValue =  Number(this.actIPC(this.goCategoriaDetalle[i].MontoCubo));
                            rangoDiff = ConsumoFacturado - r_ini + 1;
                            total_acc = rangoDiff * ipcValue;
                            lnTotal = lnTotal + total_acc;
                            swNoSalir = false;
                        } else {
                            ipcValue = Number(this.actIPC(this.goCategoriaDetalle[i].MontoCubo));
                            rangoDiff = r_fin - r_ini + 1;
                            total_acc = rangoDiff * ipcValue;
                            lnTotal = lnTotal + total_acc;
                        }
                        Total[i] = lnTotal;
                        i++;
                    } while (swNoSalir);
                }
    
                const lnResult = Math.round(lnTotal * 100) / 100;
                return lnResult;
            } else {
                if (lnConsumoMinimo <= ConsumoFacturado) {
                    const lnMonto = this.gnLecturado ? lnPrecioConMedidor : lnPrecioSinMedidor;
                    lnTotal = this.actIPC(lnMonto);
                    return Math.round(lnTotal * 100) / 100;
                } else {
                    lnTotal = 0;
                }
    
                Categoria = this.goCategoria[0].Categoria == 0 ? 1 : this.goCategoria[0].Categoria;
                ConsumoCnt = ConsumoFacturado;
                const lcFiltro = Categoria;
                // this.goCategoriaDetalle = await this.CategoriaDetalleDAL.Seek(lcFiltro, DataBaseAlias);
                this.goCategoriaDetalle = await this.GetCategoriaDetalleTable(lcFiltro);
    
                for (let j = 0; j < this.goCategoriaDetalle.length - 1; j++) {
                    if (this.goCategoriaDetalle[j].Inicio <= ConsumoCnt) {
                        break;
                    }
                }
    
                while (0 < ConsumoCnt && i + 1 <= this.goCategoriaDetalle.length) {
                    Rango = ConsumoCnt - this.goCategoriaDetalle[i].Inicio;
                    ConsumoCnt -= Rango;
                    lnTotal += Rango * this.actIPC(this.goCategoriaDetalle[i].MontoCubo);
                    i++;
                }
    
                return Math.round(lnTotal * 100) / 100;
            }
        } catch (ex) {
            console.error("Error en FacturaBLL.r_consumo: ", ex);
            return 0;
        }
    }



    async DO_GrabarDetalle(Cliente, ItemTipo, Servicio, DataBaseAlias) {
    
        // let loCategoria = await this.CategoriaDAL.GetRecDt(this.gnCategoria, DataBaseAlias);
        let loCategoria = await this.GetCategoriaTable(this.gnCategoria);
    
        // Convertir la moneda si es necesario
        if (this.gnMoneda == 1) {
            this.gnMto_Pago = Math.round(this.gnMto_Pago * this.gnTipoCambio * 100) / 100; // Redondeo a dos decimales
        }
    
        // Validaciones de montos
        if ((this.gnMto_Pago < 0 && this.gnTipo == 6) || (this.gnMto_Pago == 0 && this.gnId_Tipo == 0)) {
            console.log('no entro xdxd ');
            
            return;
        }
    
        this.gnMto_Pago = Math.round(this.gnMto_Pago * 100) / 100; // Redondear a dos decimales
    
        let lnServicio = 0;
        let lnTipoTabla = 0;
    
        // Determinación del servicio y tipo de tabla según el tipo de ítem y servicio
        if (Servicio == 0) {
            if (ItemTipo == 1) { // Consumo
                lnServicio = loCategoria[0].ItemAAPP || this.goParametrosGenerales[0].Consumo;
                lnTipoTabla = 1; // LECTURACION
            } else if (ItemTipo == 2) { // Alcantar
                lnServicio = this.goParametrosGenerales[0].Alcantar;
                lnTipoTabla = 1;
            } else if (ItemTipo == 3) { // Ley1886
                lnServicio = this.goParametrosGenerales[0].Ley1886;
                lnTipoTabla = 1;
            }
        } else {
            lnServicio = Servicio;
            lnTipoTabla = -1;
        }
    
      
        // Actualizar el ítem en la factura
        await this.FacturaDetalleDAL.ActualizarItem(this.gnFactura, Cliente, this.gnMto_Pago, lnTipoTabla, lnServicio, DataBaseAlias);
    
        // Si el servicio es 0, realizar el cálculo adicional
        if (Servicio == 0) {
            await this.CalularSobre(Cliente, ItemTipo, DataBaseAlias);
        }
      
    }

    async DO_GrabarFactura(Factura, GeneracionFactura, Cliente, Plomero, LecturaActual, Consumo, MedidorAnormalidad, DataBaseAlias, toGeneracionLectura) {
      
        let lnMto_Total = 0;
        let lnMto_Fiscal = 0;
        let lnConsumoFac = 0;
        let lnConsumoDeb = 0;
        const lnSireSe = this.goParametrosGenerales[0].Sirese;
        const lnPorcSireSe = this.goParametrosGenerales[0].PorcSirese;

      
        // Obtener montos de la factura
        const loFacturaDetalle = await this.FacturaDetalleDAL.GetMontos(Factura, lnSireSe, DataBaseAlias);

        if (loFacturaDetalle && loFacturaDetalle.length > 0) {
            lnMto_Total = loFacturaDetalle[0].MontoTotal;
            lnMto_Fiscal = loFacturaDetalle[0].MontoFiscal;
        }

        // Si lnSireSe es mayor a 0, calcular la comisión total
        if (lnSireSe > 0) {
            lnMto_Total = await this.VerComisionTotal(Factura, Cliente, lnMto_Total, lnSireSe, lnPorcSireSe, DataBaseAlias);
        }

        // Obtener los datos de GeneracionLectura
        // const GeneracionLectura = await this.GeneracionLecturaDALXD.GetIDBy(GeneracionFactura, Cliente, DataBaseAlias);
        const GeneracionLectura = [];
       
        GeneracionLectura.push({
            ConsumoFacturado: toGeneracionLectura.ConsumoFacturado,
            ConsumoDebito: toGeneracionLectura.ConsumoDebito,
        });
        
        if (GeneracionLectura && GeneracionLectura.length > 0) {
            lnConsumoFac = GeneracionLectura[0].ConsumoFacturado;
            lnConsumoDeb = GeneracionLectura[0].ConsumoDebito;
        }


         return await this.ActualizarFactura(
            Factura,
            GeneracionFactura,
            Cliente,
            Plomero,
            LecturaActual,
            Consumo,
            MedidorAnormalidad,
            lnMto_Total,
            lnMto_Fiscal,
            lnConsumoFac,
            lnConsumoDeb,
            DataBaseAlias
        );

          
    }

    async CalularSobre(Cliente, ItemTipo, DataBaseAlias) {
        try {
            for (let i = 0; i < this.goFacturaDetalle.length; i++) {
                let ID_SOBRE = this.goFacturaDetalle[i].SobreServicio;
    
                let FacturaDetalle = await this.FacturaDetalleDAL.GetRecDt(this.gnFactura, ID_SOBRE, DataBaseAlias);
    
                if (FacturaDetalle.length > 0) {
                    this.gnServicio = ID_SOBRE;
                    this.gnMto_Pago = FacturaDetalle[0].MontoPago * this.goFacturaDetalle[0].PorcentajeServicio;
                    this.gnMto_Pago = Math.round(this.gnMto_Pago * 100) / 100;
    
                    // Verificar si es crédito
                    if (this.goFacturaDetalle[0].Tipo == 6) {
                        let id_tipoCli = this.goFacturaDetalle[0].Id_Tipo;
    
                         //TODO AQUI
                        // this.goCredito = await this.CreditoDAL.GetCurCreditosCliente(Cliente, this.gnCobro, id_tipoCli, DataBaseAlias);
                        this.goCredito = await this.GetCurCreditosCliente(Cliente, this.gnCobro, id_tipoCli,);

                        if (this.goCredito.length > 1) {
                            let moneda_mes = this.goCredito[0].MonedaMes;
                            this.gnMoneda = this.goCredito[0].Moneda;
                            let psaldo = this.goCredito[0].Saldo;
                            let pmto_mes = this.gnMto_Pago;
    
                            if (moneda_mes == this.gnMoneda) {
                                this.gnMto_Pago = psaldo > pmto_mes ? pmto_mes : psaldo;
                            } else {
                                let valor = moneda_mes == 2 ? (1 / this.gnTipoCambio) : this.gnTipoCambio;
                                let pmto_mes2 = pmto_mes * valor;
                                this.gnMto_Pago = psaldo > pmto_mes2 ? pmto_mes2 : psaldo;
                            }
                        }
                    }
    
                    this.gnMto_Pago = Math.round(this.gnMto_Pago * 100) / 100;
    
                    this.gnServicio = this.goFacturaDetalle[0].Servicio;
                    await this.FacturaDetalleDAL.ActualizarItem2(this.gnFactura, this.gnServicio, this.gnMto_Pago, DataBaseAlias);
                }
            }
        } catch (ex) {
            console.error(`Error en FacturaBLL.CalularSobre(): ${ex}`);
        }
    }
    

    async verAlcantar(Cliente, Plomero, DataBaseAlias) {
        this.gnServicio = -1;
        try {
            this.gnServicio = Number(await this.goParametrosGenerales[0].Alcantar);
            this.gnTipo = 1;
            
            if (this.gnServicio == 0) return;
    
            if (this.goCliente[0].Cloaca == 0) return;
    
            const lnConsumoFac = this.goGeneracionLectura[0].ConsumoFacturado;
    
            if (this.goCategoria[0].MonedaAASS > 0) {
                this.gnMoneda = this.goCategoria[0].MonedaAASS;
            } else {
                this.gnMoneda = this.goCategoria[0].Moneda;
            }
    
            this.gnMto_Pago = await this.r_Alcantar(lnConsumoFac, Cliente, DataBaseAlias);
            this.gnMoneda = 2;
            let lnMontoLey1294 = this.gnMto_Pago;
            await this.DO_GrabarDetalle(Cliente, 2, 0, DataBaseAlias); // 2 = Alcantar
    
            // Ley 1294: Cargo fijo y consumo
            if (this.goCategoria[0].CargoAASS > 0) {
                this.gnServicio = this.goCategoria[0].CargoAASS;
                this.gnTipo = 1;
                this.gnId_Tipo = this.gnGeneracionFactura;
                this.gnMto_Pago = this.goCategoria[0].MontoCargoAASS;
    
                if (this.goCategoria[0].MonedaAASS > 0) {
                    this.gnMoneda = this.goCategoria[0].MonedaAASS;
                } else {
                    this.gnMoneda = this.goCategoria[0].Moneda;
                }
    
                await this.DO_GrabarDetalle(Cliente, this.gnTipo, this.gnServicio, DataBaseAlias);
                lnMontoLey1294 += this.gnMto_Pago;
            }
        } catch (error) {
            console.error("Error en verAlcantar:", error);
        }
    }

    
    async r_Alcantar(ConsumoFacturado, Cliente, DataBaseAlias) {

    let tnTotal;
    let lnMto_IPC = 0;
    let lnConsumoCnt;
    let i = -1;

    const lnPrecioConMedidor = this.goCategoria[0].PrecioConMedidorAlcantarillado;
    const lnPrecioSinMedidor = this.goCategoria[0].PrecioSinMedidorAlcantarillado;
    const lnConsumoMinimo = this.goCategoria[0].ConsumoMinimo;

    const lnMonto = this.gnLecturado ? lnPrecioConMedidor : lnPrecioSinMedidor;
    tnTotal = Number(this.actIPC(lnMonto));

    if (!this.gnLecturado) return tnTotal;

    const Categoria = this.gnCategoria == 0 ? 1 : this.gnCategoria;
    lnConsumoCnt = ConsumoFacturado;

    // const CategoriaDetalle = await this.CategoriaDetalleDAL.Seek(this.gnCategoria, DataBaseAlias);
    const CategoriaDetalle = await this.GetCategoriaDetalleTable(this.gnCategoria);
    let r_ini = 0;
    let r_fin = 0;
    i = 0;

    if (ConsumoFacturado > lnConsumoMinimo) {
        let swNoSalir = true;
        do {
            if (i > CategoriaDetalle.length - 1) {
                swNoSalir = false;
            }

            r_ini = CategoriaDetalle[i].Inicio;
            r_fin = CategoriaDetalle[i].Fin;

            if (r_ini <= ConsumoFacturado && ConsumoFacturado <= r_fin) {
                lnMto_IPC = Number(this.actIPC(CategoriaDetalle[i].MontoAlcantarillado));
                tnTotal += (ConsumoFacturado - r_ini + 1) * lnMto_IPC;
                swNoSalir = false;
            } else {
                lnMto_IPC =  Number(this.actIPC(CategoriaDetalle[i].MontoAlcantarillado));
                tnTotal += (r_fin - r_ini + 1) * lnMto_IPC;
            }

            i++;
        } while (swNoSalir);
    }

    return Math.round(tnTotal * 100) / 100;
    }


    async verLey1886(Cliente, DataBaseAlias) {
        this.gnServicio = this.goParametrosGenerales[0].Ley1886;

        if (this.gnServicio > 0) {
            if (this.goCliente[0].Seguro != 0) {
                this.gnTipo = 1;
                this.gnId_Tipo = this.gnGeneracionFactura;
                this.gnMoneda = this.goCategoria[0].Moneda;

                const lnConsumo = this.goGeneracionLectura[0].ConsumoFacturado;
                let lnMto_Pago = await this.l_consumo(lnConsumo, Cliente, DataBaseAlias);
                this.gnMto_Pago = - Number(this.goParametrosGenerales[0].Ley1886Por) * Number(lnMto_Pago);

        
                if (this.gnMoneda == 3) {
                    this.gnMoneda = 2;
                }

                // 3 = Ley1886
                await this.DO_GrabarDetalle(Cliente, 3, 0, DataBaseAlias);
            }
        }
    }

    async l_consumo(ConsumoArea, Cliente, DataBaseAlias) { 
        let rtotal;
        const consumoLey = this.goParametrosGenerales[0].Ley1886Cub;
    
        if (ConsumoArea <= consumoLey) {
            rtotal = await this.r_consumo(ConsumoArea, Cliente, DataBaseAlias);
        } else {
            rtotal = await this.r_consumo(consumoLey, Cliente, DataBaseAlias);
        }
    
        return Math.round(rtotal * 100) / 100; // Redondea a 2 decimales
    }



    

    async ActualizarFactura(Factura, GeneracionFactura, Cliente, Plomero, LecturaActual, Consumo, MedidorAnormalidad,
        MontoTotal, MontoFiscal, ConsumoFacturado, ConsumoDebito, DataBaseAlias) {
   
        //validar que los datos esten llegando correctamente, que no sena nan o undefined
        // if (MontoTotal == undefined || MontoTotal == NaN || MontoTotal == null) {
        //     return -1;
        // }
    


        // Abre la base de datos y comienza una transacción de lectura/escritura
        const db = await getDataBase();
        const tx = db.transaction('FACTURA', 'readwrite');
        const store = tx.objectStore('FACTURA');
    
        // Obtén la factura que deseas actualizar
        const laFactura = await store.getAll(Factura); // Asumiendo que Factura y Cliente son claves
    
        let loFactura = {};
            laFactura.forEach((loFac) => {
                if (loFac.Cliente == Cliente) {
                    loFactura = loFac;
                }
            });
            

 
        // Si la factura existe, actualiza los campos
        const loFechaHora = new FechaHora();

        if (loFactura) {
            loFactura.MontoTotal = MontoTotal;
            loFactura.MontoFiscal = MontoFiscal;
            loFactura.MontoVence = MontoTotal;
            loFactura.LecturaActual = LecturaActual;
            loFactura.Consumo = Consumo;
            loFactura.FechaLectura = loFechaHora.getFechaHora();
            loFactura.Hora = loFechaHora.getHora();
            loFactura.NumeroFactura = 0;
            loFactura.FactorCubo = 0;
            loFactura.Mora = 0;
            loFactura.OrdenDosificacion = 0;
            loFactura.NumeroCopias = 0;
            loFactura.MedidorAnormalidad = MedidorAnormalidad;
            loFactura.GeneracionFactura = GeneracionFactura;
            // loFactura.Usr = 'UsuarioActual'; // Puedes obtener el usuario autenticado si usas alguna lógica para manejar usuarios
            loFactura.ConsumoFacturado = ConsumoFacturado;
            loFactura.ConsumoDebito = ConsumoDebito;
    
            // Actualizar la factura en IndexedDB
            await store.put(loFactura);
        }
    
        // Completa la transacción
        await tx.done;
    
        return 0;
    }
    



}
